export function MeaningResults({ results, timeSec, ptsEarned, onDone }) {
  const answered = results.filter(r => !r.skipped);
  const correct = answered.filter(r => r.correct).length;
  const pct = answered.length ? Math.round((correct / answered.length) * 100) : 0;
  const color = pct >= 80 ? "var(--green)" : pct >= 60 ? "var(--amber)" : "var(--red)";
  const mins = Math.floor(timeSec / 60), secs = timeSec % 60;
  return (
    <div className="results-wrap">
      <div style={{ width: "100%", maxWidth: 500 }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ fontFamily: "'Lora',serif", fontSize: "1.75rem", fontWeight: 700, color: "var(--navy)", marginTop: "1rem" }}>Meaning Quiz Complete!</div>
          <div className="score-ring" style={{ borderColor: color }}>
            <div className="score-big" style={{ color }}>{pct}%</div>
            <div className="score-frac">{correct}/{answered.length}</div>
          </div>
          <div style={{ display: "flex", justifyContent: "center", gap: "1.75rem", marginBottom: "1rem", color: "var(--muted)", fontSize: ".87rem", fontWeight: 600 }}>
            <span>⏱ {mins}m {secs}s</span><span>✅ {correct} correct</span><span>❌ {answered.length - correct} wrong</span>
          </div>
          {ptsEarned > 0 && (
            <div style={{ textAlign: "center", marginBottom: "1.2rem" }}>
              <div style={{ display: "inline-flex", alignItems: "center", gap: ".5rem", background: "var(--amber-light)", color: "var(--amber)", fontWeight: 800, fontSize: "1rem", padding: ".55rem 1.25rem", borderRadius: 999 }}>
                ⭐ +{ptsEarned} points earned!
              </div>
            </div>
          )}
        </div>
        {pct === 100 && <div style={{ textAlign: "center", padding: "1.5rem 0" }}><div style={{ fontSize: "4rem" }}>🎉</div><div style={{ fontWeight: 800, color: "var(--green)", marginTop: ".5rem" }}>Perfect score!</div></div>}
        <button className="done-btn" style={{ width: "100%" }} onClick={onDone}>Back to Home</button>
      </div>
    </div>
  );
}
